import Vue from 'vue'
import { getStoredLocale } from './localeStorage'

// add translations directly to the application
Vue.i18n.add('br', require('./pt_br.json'))
Vue.i18n.add('en', require('./en.json'))
Vue.i18n.add('es', require('./es.json'))
Vue.i18n.add('zh', require('./zh.json'))

// set the start locale to use (restore from localStorage when available)
Vue.i18n.set(getStoredLocale())

// set fallback for non-translated strings
Vue.i18n.fallback('en')

export { getStoredLocale, setStoredLocale, LOCALE_STORAGE_KEY, SUPPORTED_LOCALES } from './localeStorage'
